import { _ as re } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.symbol.description-6025a604.js";
import "./es.array.is-array-7a29277f.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import { BREAKPOINTS as Ve } from "@ucl/shared-component-foundations";
import { c as w } from "./index-8b07dec9.js";
import F, { useState as S, useEffect as Pe, useContext as Ke } from "react";
import t, { css as l } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as Ge } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as Je } from "./useWindowSize.js";
import { Button as Be } from "./button.js";
import { Disclosures as Qe } from "./disclosure.js";
import { a as M } from "./index-5d0f31c6.js";
import { Image as He } from "./image.js";
import { TableContext as Xe } from "./provider.js";
import { T as Ye } from "./tableContainer-531abf1b.js";
import { T as x } from "./tableV1-80a39fe6.js";
import { uniqueId as he } from "./uniqueId.js";
import { p as Se } from "./index-8b032e93.js";
import { P as X } from "./popupTip-06ee114c.js";
import "./es.string.starts-with-a6645e0a.js";
import "./es.string.link-fd2676c6.js";
import { jsx as o, jsxs as f } from "react/jsx-runtime";
import { Tooltip as Y } from "./tooltip.js";
import { s as Ze } from "./index-fa01101f.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.function.name-b230e7d4.js";
import "./es.string.iterator-5de8a61e.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.regexp.to-string-e800d529.js";
import "./es.string.search-d27ec57a.js";
import "./es.string.trim-6e13db75.js";
import "./index-f5b44da3.js";
import "./carousel.js";
import "./label.js";
import "./es.array.from-fe752fa6.js";
import "./es.date.to-string-6ed49878.js";
import "./es.global-this-a7f40ce1.js";
import { S as en } from "./singleSelectInput-6bdc2a66.js";
import "./export-cdcbfb2b.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./iterate-13ada9e5.js";
import "./array-iteration-759bfbfa.js";
import "./function-apply-4756dee6.js";
import "./create-property-f9780ed1.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./combineRefs-c9ad2c39.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./es.array.join-c1bca812.js";
import "./aspectRatio.js";
import "./species-constructor-00346775.js";
import "./string-trim-14e37ad3.js";
import "./mediaDisclosureButton.js";
import "./es.parse-int-d7709701.js";
import "./es.array.reduce-2985ed2c.js";
import "./environment-is-node-a035d787.js";
import "./es.array.splice-801adf1d.js";
import "./es.string.small-23219181.js";
import "./string-html-forced-a746405b.js";
import "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./index-0ec2583e.js";
import "react-dom";
import "./usePopoverIndex.js";
import "./aria.js";
import "./divider.js";
import "./focusTrap.js";
import "./es.array.index-of-084b82ab.js";
import "./useClient.js";
import "./useOnClickOutside.js";
import "./closeButton.js";
import "./iconButton.js";
import "./getElementPosition-8d0dbc61.js";
import "./es.parse-float-020a2ae0.js";
import "./___vite-browser-external_commonjs-proxy-5e28079b.js";
import "./objectDestructuringEmpty-69c165c0.js";
import "./es.function.bind-b4bdcd4b.js";
import "@ucl/ucl-translation";
import "./helperText.js";
import "./index-f2264f1e.js";
import "./screenReaderOnly.js";
import "./accessibility.js";
import "./text.js";
import "./cloneSlots-622cf8c9.js";
import "./link.js";
import "./badge.js";
import "./useMediaQuery.js";
var $e = function(e, a) {
  return e === void 0 && (e = ""), a === void 0 && (a = {}), Ze(e, Object.assign({
    allowedAttributes: {
      "*": ["style", "class", "tabindex", "role", "aria-label"],
      a: ["href", "target"]
    }
  }, a));
}, nn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableHeaderWrapper__CheckedWrapper",
  componentId: "sc-1immhgv-0"
})(["&.Checked-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.CheckedWrapper);
}), on = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableHeaderWrapper__UncheckedWrapper",
  componentId: "sc-1immhgv-1"
})(["&.Unchecked-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.UncheckedWrapper);
}), _e = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableHeaderWrapper__InformationWrapper",
  componentId: "sc-1immhgv-2"
})(["&.Information-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.InformationWrapper);
}), rn = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableHeaderWrapper__TextWrapper",
  componentId: "sc-1immhgv-3"
})(["&.Text-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.TextWrapper);
}), Ne = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableHeaderWrapper__TextContainer",
  componentId: "sc-1immhgv-4"
})(["&.TextContainer{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableHeaderTextContainer);
}), an = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableHeaderWrapper__MarketingComparisonTableMobileViewHeaderTooltipContainer",
  componentId: "sc-1immhgv-5"
})(["&.HeaderTooltip-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewHeaderTooltipContainer);
}), xe = function(e) {
  var a = e.type, y = e.informationTooltipProp, h = e.informationPopuptipProp, d = e.textValue, T = e.contentAlignment, s = e.informationOption, I = e.size, _ = e.textVariant;
  return a === "checked" && /* @__PURE__ */ o(nn, {
    className: w(["Checked-wrapper"]),
    children: /* @__PURE__ */ o(M, {
      icon: "checkmarkFilled",
      size: "m"
    })
  }) || a === "unchecked" && /* @__PURE__ */ o(on, {
    className: w(["Unchecked-wrapper"]),
    children: /* @__PURE__ */ o(M, {
      icon: "decreaseFilled",
      size: "m"
    })
  }) || a === "information-popuptip" && h && /* @__PURE__ */ o(_e, {
    className: w(["Information-wrapper"]),
    children: /* @__PURE__ */ o(X, Object.assign({}, h, {
      children: /* @__PURE__ */ o(M, {
        tabIndex: 0,
        icon: "information",
        size: "m"
      })
    }))
  }) || a === "information-tooltip" && y && /* @__PURE__ */ o(_e, {
    className: w(["Information-wrapper"]),
    children: /* @__PURE__ */ o(Y, Object.assign({}, y, {
      children: /* @__PURE__ */ o(M, {
        tabIndex: 0,
        icon: "information",
        size: "m"
      })
    }))
  }) || a === "text" && /* @__PURE__ */ f(Ne, {
    className: "TextContainer",
    children: [/* @__PURE__ */ o(rn, {
      className: w(["Text-wrapper", "Text-wrapper--" + I, "Text-wrapper--text-" + T, "Text-wrapper--variant--" + _]),
      children: typeof d == "string" && /* @__PURE__ */ f("div", {
        children: [" ", Se($e("" + d || "")), " "]
      }) || d
    }), s && /* @__PURE__ */ f(an, {
      className: "HeaderTooltip-container",
      children: [(s == null ? void 0 : s.type) === "information-popuptip" && /* @__PURE__ */ o(X, Object.assign({}, s == null ? void 0 : s.informationPopuptipProp, {
        children: /* @__PURE__ */ o(M, {
          tabIndex: 0,
          icon: "information",
          size: "m"
        })
      })), (s == null ? void 0 : s.type) === "information-tooltip" && /* @__PURE__ */ o(Y, Object.assign({}, s == null ? void 0 : s.informationTooltipProp, {
        children: /* @__PURE__ */ o(M, {
          tabIndex: 0,
          icon: "information",
          size: "m"
        })
      }))]
    })]
  });
}, tn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableValueWrapper__CheckedWrapper",
  componentId: "sc-7gmsvr-0"
})(["&.Checked-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.CheckedWrapper);
}), ln = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableValueWrapper__UncheckedWrapper",
  componentId: "sc-7gmsvr-1"
})(["&.Unchecked-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.UncheckedWrapper);
}), ye = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableValueWrapper__InformationWrapper",
  componentId: "sc-7gmsvr-2"
})(["&.Information-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.InformationWrapper);
}), mn = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableValueWrapper__TextWrapper",
  componentId: "sc-7gmsvr-3"
})(["&.Text-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.TextWrapper);
}), pn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableValueWrapper__TextContainer",
  componentId: "sc-7gmsvr-4"
})(["&.Text-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableValueWrapperTextContainer);
}), de = function(e) {
  var a = e.type, y = e.informationTooltipProp, h = e.informationPopuptipProp, d = e.textValue, T = e.contentAlignment, s = e.informationOption, I = e.textVariant, _ = I === void 0 ? "value" : I;
  return a === "checked" && /* @__PURE__ */ o(tn, {
    className: w(["Checked-wrapper", "Checked-wrapper--icon-" + T]),
    children: /* @__PURE__ */ o(M, {
      icon: "checkmarkFilled",
      size: "m",
      "aria-label": "Included"
    })
  }) || a === "unchecked" && /* @__PURE__ */ o(ln, {
    className: w(["Unchecked-wrapper", "Unchecked-wrapper--icon-" + T]),
    children: /* @__PURE__ */ o(M, {
      icon: "decreaseFilled",
      size: "m",
      "aria-label": "Not Included"
    })
  }) || a === "information-popuptip" && h && /* @__PURE__ */ o(ye, {
    className: w(["Information-wrapper", "Information-wrapper--icon-" + T]),
    children: /* @__PURE__ */ o(X, Object.assign({}, h, {
      children: /* @__PURE__ */ o(M, {
        tabIndex: 0,
        icon: "information",
        size: "m",
        "aria-label": "Information"
      })
    }))
  }) || a === "information-tooltip" && y && /* @__PURE__ */ o(ye, {
    className: w(["Information-wrapper", "Information-wrapper--icon-" + T]),
    children: /* @__PURE__ */ o(Y, Object.assign({}, y, {
      children: /* @__PURE__ */ o(M, {
        tabIndex: 0,
        icon: "information",
        size: "m",
        "aria-label": "Information"
      })
    }))
  }) || a === "text" && /* @__PURE__ */ f(pn, {
    className: "Text-container",
    children: [/* @__PURE__ */ o(mn, {
      className: w(["Text-wrapper", "Text-wrapper--variant-" + _, "Text-wrapper--text-" + T]),
      children: typeof d == "string" && /* @__PURE__ */ f("div", {
        children: [" ", Se($e("" + d || "")), " "]
      }) || d
    }), s && /* @__PURE__ */ f(xn, {
      className: "MarketingComparisonTableMobileView-body-tooltip-container",
      children: [(s == null ? void 0 : s.type) === "information-popuptip" && /* @__PURE__ */ o(X, Object.assign({}, s == null ? void 0 : s.informationPopuptipProp, {
        children: /* @__PURE__ */ o(M, {
          tabIndex: 0,
          icon: "information",
          size: "m",
          "aria-label": "Information"
        })
      })), (s == null ? void 0 : s.type) === "information-tooltip" && /* @__PURE__ */ o(Y, Object.assign({}, s == null ? void 0 : s.informationTooltipProp, {
        children: /* @__PURE__ */ o(M, {
          tabIndex: 0,
          icon: "information",
          size: "m",
          "aria-label": "Information"
        })
      }))]
    })]
  });
}, sn = ["isColumnButtonEnabled", "buttonText"], un = ["isColumnButtonEnabled", "buttonText"], cn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewContainer",
  componentId: "sc-1t0ka0u-0"
})(["&.MarketingComparisonTableMobileView-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewContainer);
}), dn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewHeaderContainer",
  componentId: "sc-1t0ka0u-1"
})(["&.MarketingComparisonTableMobileView-header-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewHeaderContainer);
}), Cn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewBodyContainer",
  componentId: "sc-1t0ka0u-2"
})(["&.MarketingComparisonTableMobileView-body-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewBodyContainer);
}), bn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewBodyWrapper",
  componentId: "sc-1t0ka0u-3"
})(["&.MarketingComparisonTableMobileView-body-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewBodyWrapper);
}), gn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewBody",
  componentId: "sc-1t0ka0u-4"
})(["&.MarketingComparisonTableMobileView-body{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewBody);
}), Tn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewHeader",
  componentId: "sc-1t0ka0u-5"
})(["&.MarketingComparisonTableMobileView-header{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewHeader);
}), vn = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewHeaderTitle",
  componentId: "sc-1t0ka0u-6"
})(["&.MarketingComparisonTableMobileView-header-title{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewHeaderTitle);
}), fn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewHeaderTitleWrapper",
  componentId: "sc-1t0ka0u-7"
})(["&.MarketingComparisonTableMobileView-header-title-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewHeaderTitleWrapper);
}), kn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewHeaderTitleContainer",
  componentId: "sc-1t0ka0u-8"
})(["&.MarketingComparisonTableMobileView-header-title-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewHeaderTitleContainer);
}), Mn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewHeaderTooltipContainer",
  componentId: "sc-1t0ka0u-9"
})(["&.MarketingComparisonTableMobileVie-header-tooltip-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewHeaderTooltipContainer);
}), wn = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewHeaderDescription",
  componentId: "sc-1t0ka0u-10"
})(["&.MarketingComparisonTableMobileView-description{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewDescription);
}), Vn = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewBodyValue",
  componentId: "sc-1t0ka0u-11"
})(["&.MarketingComparisonTableMobileView-body-value{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewBodyValue);
}), hn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewBodyValueWrapper",
  componentId: "sc-1t0ka0u-12"
})(["&.MarketingComparisonTableMobileView-body-value-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewBodyValueWrapper);
}), _n = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewBodyValueContainer",
  componentId: "sc-1t0ka0u-13"
})(["&.MarketingComparisonTableMobileView-body-value-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewBodyValueContainer);
}), xn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewBodyTooltipContainer",
  componentId: "sc-1t0ka0u-14"
})(["&.MarketingComparisonTableMobileView-body-tooltip-container{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewBodyTooltipContainer);
}), yn = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableMobileViewButtonWrapper",
  componentId: "sc-1t0ka0u-15"
})(["&.MarketingComparisonTableMobileViewButton-wrapper{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableMobileViewButtonWrapper);
}), In = /* @__PURE__ */ t.div.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableHeaderContainer",
  componentId: "sc-1t0ka0u-16"
})(["&.MarketingComparisonTableHeaderContainer{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableHeaderContainer);
}), Pn = /* @__PURE__ */ t.span.withConfig({
  displayName: "marketingComparisonTableMobileView__MarketingComparisonTableEmptyContainer",
  componentId: "sc-1t0ka0u-17"
})(["&.MarketingComparisonTableEmptyContainer{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableColumnButton);
}), Bn = function(e) {
  var a = e.headerValues, y = e.rowValues, h = e.isColumnButtonEnabled, d = S([]), T = d[0], s = d[1], I = S({
    firstColumn: [],
    secondColumn: []
  }), _ = I[0], ae = I[1], Z = S({
    firstColumn: "",
    secondColumn: ""
  }), W = Z[0], q = Z[1], ee = S({
    firstColumn: "",
    secondColumn: ""
  }), O = ee[0], K = ee[1], ne = S({
    firstColumn: "small",
    secondColumn: "small"
  }), L = ne[0], G = ne[1], oe = S({
    columnLabels: [],
    firstColumn: [],
    secondColumn: []
  }), n = oe[0], V = oe[1], v = S({
    firstColumn: !1,
    secondColumn: !1
  }), P = v[0], z = v[1], A = S({
    firstColumn: "",
    secondColumn: ""
  }), E = A[0], D = A[1], J = S({
    firstColumn: {},
    secondColumn: {}
  }), Q = J[0], ie = J[1], Ce = S(), m = Ce[0], We = Ce[1], Oe = function(u, c, p) {
    var k = p.filter(function(b) {
      if (b.value !== u && b.value !== c)
        return !0;
    });
    return {
      firstColumn: k,
      secondColumn: k
    };
  }, te = function(u, c, p) {
    var k, b, g, B, N, H, j, R, U = (k = u[c ?? 0]) == null ? void 0 : k.value, le = (b = u[p ?? 1]) == null ? void 0 : b.value, me = (g = (B = u[c ?? 0]) == null ? void 0 : B.size) != null ? g : "small", Ae = (N = (H = u[p ?? 1]) == null ? void 0 : H.size) != null ? N : "small", pe = a.findIndex(function($) {
      return $.id === U;
    }), se = a.findIndex(function($) {
      return $.id === le;
    }), be = [], ge = [], Te = /* @__PURE__ */ new Set(), ve = [];
    y.forEach(function($) {
      Te.has($.cellData[0].valueProp.textValue) || (Te.add($.cellData[0].valueProp.textValue), ve.push($.cellData[0])), be.push($.cellData[pe]), ge.push($.cellData[se]);
    });
    var Ee = {
      columnLabels: ve,
      firstColumn: be,
      secondColumn: ge
    }, ue = ((j = a[pe]) == null ? void 0 : j.columnButton) || {}, fe = ue.isColumnButtonEnabled, je = fe === void 0 ? !1 : fe, ke = ue.buttonText, Re = ke === void 0 ? "" : ke, Ue = re(ue, sn), ce = ((R = a[se]) == null ? void 0 : R.columnButton) || {}, Me = ce.isColumnButtonEnabled, Le = Me === void 0 ? !1 : Me, we = ce.buttonText, De = we === void 0 ? "" : we, Fe = re(ce, un), qe = Oe(U, le, u);
    ie({
      firstColumn: Ue,
      secondColumn: Fe
    }), z({
      firstColumn: je,
      secondColumn: Le
    }), D({
      firstColumn: Re,
      secondColumn: De
    }), V(Ee), We({
      firstColumn: a[pe],
      secondColumn: a[se]
    }), ae(qe), G({
      firstColumn: me,
      secondColumn: Ae
    });
  };
  Pe(function() {
    var r, u, c, p, k = a.map(function(g) {
      var B = typeof g.textValue == "string" && g.textValue || g.altText || "";
      return {
        value: g.id,
        label: B,
        size: g.textSize || "small"
      };
    }), b = k.slice(1, k.length);
    s(b), te(b), q({
      firstColumn: (r = b[0]) == null ? void 0 : r.label,
      secondColumn: (u = b[1]) == null ? void 0 : u.label
    }), K({
      firstColumn: (c = b[0]) == null ? void 0 : c.value,
      secondColumn: (p = b[1]) == null ? void 0 : p.value
    });
  }, [a]);
  var ze = function(u, c) {
    var p = T.findIndex(function(g) {
      return g.value === u.value;
    });
    if (p > -1)
      if (c) {
        var k = T.findIndex(function(g) {
          return g.value === O.secondColumn;
        });
        te(T, p, k), q(Object.assign({}, W, {
          firstColumn: T[p].label
        })), K(Object.assign({}, O, {
          firstColumn: T[p].value
        }));
      } else {
        var b = T.findIndex(function(g) {
          return g.value === O.firstColumn;
        });
        te(T, b, p), q(Object.assign({}, W, {
          secondColumn: T[p].label
        })), K(Object.assign({}, O, {
          secondColumn: T[p].value
        }));
      }
  }, C = function(u) {
    return u === 1 ? "firstColumn" : "secondColumn";
  };
  return /* @__PURE__ */ f(cn, {
    className: w(["MarketingComparisonTableMobileView-container"]),
    children: [/* @__PURE__ */ o(dn, {
      className: "MarketingComparisonTableMobileView-header-container",
      children: [1, 2].map(function(r) {
        var u, c, p, k, b, g, B, N, H, j, R, U;
        return /* @__PURE__ */ f(Tn, {
          className: "MarketingComparisonTableMobileView-header",
          id: "" + r,
          children: [a.length > 3 && /* @__PURE__ */ o(en, {
            menuDirection: "down_auto",
            exceedOverflow: !0,
            isSearchable: !1,
            className: "single-select-input",
            size: "small",
            placeholder: r === 1 && W.firstColumn || W.secondColumn,
            options: r === 1 && _.firstColumn || _.secondColumn,
            onOptionSelect: function(me) {
              ze(me, r === 1);
            }
          }, _.firstColumn.length + "-" + _.secondColumn.length), /* @__PURE__ */ f(In, {
            className: "MarketingComparisonTableHeaderContainer",
            children: [(m == null || (u = m[C(r)]) == null ? void 0 : u.imageProps) && /* @__PURE__ */ o(He, Object.assign({}, m == null || (c = m[C(r)]) == null ? void 0 : c.imageProps, {
              src: (m == null || (p = m[C(r)]) == null || (p = p.imageProps) == null ? void 0 : p.src) || void 0,
              minHeight: "84px",
              variant: "none"
            })), /* @__PURE__ */ f(kn, {
              className: "MarketingComparisonTableMobileView-header-title-container",
              children: [/* @__PURE__ */ f(fn, {
                className: "MarketingComparisonTableMobileView-header-title-wrapper",
                children: [/* @__PURE__ */ o(vn, {
                  className: w(["MarketingComparisonTableMobileView-header-title", "MarketingComparisonTableMobileView-header-title--" + (L == null ? void 0 : L[C(r)]), "MarketingComparisonTableMobileView-header-title--text-" + (m == null || (k = m[C(r)]) == null ? void 0 : k.contentAlignment)]),
                  children: m == null || (b = m[C(r)]) == null ? void 0 : b.textValue
                }), /* @__PURE__ */ o(wn, {
                  className: w(["MarketingComparisonTableMobileView-description", "MarketingComparisonTableMobileView-description--text-" + (m == null || (g = m[C(r)]) == null ? void 0 : g.contentAlignment)]),
                  children: m == null || (B = m[C(r)]) == null ? void 0 : B.description
                })]
              }), (m == null || (N = m[C(r)]) == null ? void 0 : N.informationOption) && /* @__PURE__ */ f(Mn, {
                className: "MarketingComparisonTableMobileVie-header-tooltip-container",
                children: [(m == null || (H = m[C(r)]) == null || (H = H.informationOption) == null ? void 0 : H.type) === "information-popuptip" && /* @__PURE__ */ o(X, Object.assign({}, m == null || (j = m[C(r)]) == null || (j = j.informationOption) == null ? void 0 : j.informationPopuptipProp, {
                  children: /* @__PURE__ */ o(M, {
                    tabIndex: 0,
                    icon: "information",
                    size: "m"
                  })
                })), (m == null || (R = m[C(r)]) == null || (R = R.informationOption) == null ? void 0 : R.type) === "information-tooltip" && /* @__PURE__ */ o(Y, Object.assign({}, m == null || (U = m[C(r)]) == null || (U = U.informationOption) == null ? void 0 : U.informationTooltipProp, {
                  children: /* @__PURE__ */ o(M, {
                    tabIndex: 0,
                    icon: "information",
                    size: "m"
                  })
                }))]
              })]
            })]
          })]
        }, r);
      })
    }), /* @__PURE__ */ f(Cn, {
      className: "MarketingComparisonTableMobileView-body-container",
      children: [n == null ? void 0 : n.columnLabels.map(function(r, u) {
        return /* @__PURE__ */ o(bn, {
          className: "MarketingComparisonTableMobileView-body-wrapper",
          children: [1, 2].map(function(c) {
            var p, k, b, g, B, N, H;
            return /* @__PURE__ */ o(gn, {
              className: "MarketingComparisonTableMobileView-body",
              children: /* @__PURE__ */ o(_n, {
                className: "MarketingComparisonTableMobileView-body-value-container",
                children: /* @__PURE__ */ f(hn, {
                  className: "MarketingComparisonTableMobileView-body-value-wrapper",
                  children: [/* @__PURE__ */ o(de, {
                    type: r == null ? void 0 : r.valueProp.type,
                    informationPopuptipProp: r == null ? void 0 : r.valueProp.informationPopuptipProp,
                    informationTooltipProp: r == null ? void 0 : r.valueProp.informationTooltipProp,
                    textValue: r == null ? void 0 : r.valueProp.textValue,
                    contentAlignment: m == null || (p = m[C(c)]) == null ? void 0 : p.contentAlignment,
                    informationOption: r == null ? void 0 : r.informationOption,
                    textVariant: "label"
                  }), /* @__PURE__ */ o(Vn, {
                    className: w(["MarketingComparisonTableMobileView-body-value", "MarketingComparisonTableMobileView-body-value--" + L[C(c)]]),
                    children: /* @__PURE__ */ o(de, {
                      type: n == null || (k = n[C(c)][u]) == null ? void 0 : k.valueProp.type,
                      informationPopuptipProp: n == null || (b = n[C(c)][u]) == null ? void 0 : b.valueProp.informationPopuptipProp,
                      informationTooltipProp: n == null || (g = n[C(c)][u]) == null ? void 0 : g.valueProp.informationTooltipProp,
                      textValue: n == null || (B = n[C(c)][u]) == null ? void 0 : B.valueProp.textValue,
                      contentAlignment: m == null || (N = m[C(c)]) == null ? void 0 : N.contentAlignment,
                      informationOption: n == null || (H = n[C(c)][u]) == null ? void 0 : H.informationOption
                    })
                  })]
                })
              })
            });
          })
        });
      }), h && /* @__PURE__ */ f(yn, {
        className: w(["MarketingComparisonTableMobileViewButton-wrapper"]),
        children: [P.firstColumn && /* @__PURE__ */ o(Ie, Object.assign({
          className: "MarketingComparisonTableColumnButton"
        }, Q.firstColumn, {
          children: E.firstColumn
        })) || /* @__PURE__ */ o(Pn, {
          className: "MarketingComparisonTableEmptyContainer"
        }), P.secondColumn && /* @__PURE__ */ o(Ie, Object.assign({
          className: "MarketingComparisonTableColumnButton"
        }, Q.secondColumn, {
          children: E.secondColumn
        }))]
      })]
    })]
  });
}, Hn = ["headerValues", "rowValues", "disclosures"], Sn = ["isColumnButtonEnabled", "buttonText", "as"], Ie = /* @__PURE__ */ t(Be).withConfig({
  displayName: "marketingComparisonTable__MarketingComparisonTableColumnButton",
  componentId: "sc-1v627x-0"
})(["&.MarketingComparisonTableColumnButton{", ";}"], function(i) {
  var e = i.theme.components.marketingComparisonTable;
  return l(e.MarketingComparisonTableColumnButton);
}), Zi = function(e) {
  var a = e.headerValues, y = e.rowValues, h = y === void 0 ? [] : y, d = e.disclosures, T = re(e, Hn), s = Ge({
    label: "MarketingComparisonTable"
  }), I = F.useState(!0), _ = I[0], ae = I[1], Z = Je(), W = Z.width, q = Ke(Xe), ee = q.setIsStickyColumnEnabled, O = F.useState([]), K = O[0], ne = O[1], L = F.useState(!1), G = L[0], oe = L[1];
  return F.useEffect(function() {
    ne(h);
  }, [h]), F.useEffect(function() {
    oe(!!(a != null && a.find(function(n) {
      return n == null ? void 0 : n.columnButton;
    })));
  }, [a]), F.useEffect(function() {
    ee(!1);
  }, []), Pe(function() {
    ae(!1);
  }, []), /* @__PURE__ */ f(Ye, Object.assign({
    className: w(["TableContainer"])
  }, s, {
    children: [!_ && W >= Ve.laptopMin && /* @__PURE__ */ f(x, Object.assign({
      style: {
        border: "unset",
        overflow: "unset"
      },
      isMarketingTable: !0,
      isEmpty: !1
    }, T, {
      children: [/* @__PURE__ */ o(x.Head, {
        marketingTable: !0,
        children: a.map(function(n) {
          var V;
          return /* @__PURE__ */ o(x.Header, {
            marketingTable: !0,
            children: /* @__PURE__ */ f(x.CellContent, {
              $contentAlignment: (n == null ? void 0 : n.contentAlignment) || "center",
              $flexDirection: "column",
              children: [typeof (n == null ? void 0 : n.leadingComponents) == "string" ? /* @__PURE__ */ o(M, {
                icon: n == null ? void 0 : n.leadingComponents
              }) : n == null ? void 0 : n.leadingComponents, n.imageProps && /* @__PURE__ */ o(He, Object.assign({}, n == null ? void 0 : n.imageProps, {
                src: (V = n.imageProps) == null ? void 0 : V.src,
                variant: "none"
              })), (n == null ? void 0 : n.textValue) && /* @__PURE__ */ o(xe, {
                type: "text",
                size: (n == null ? void 0 : n.textSize) || "medium",
                contentAlignment: (n == null ? void 0 : n.contentAlignment) || "center",
                textValue: n == null ? void 0 : n.textValue,
                informationOption: n == null ? void 0 : n.informationOption
              }), typeof (n == null ? void 0 : n.trailingComponent) == "string" ? /* @__PURE__ */ o(M, {
                icon: n == null ? void 0 : n.trailingComponent
              }) : n == null ? void 0 : n.trailingComponent, /* @__PURE__ */ o(Ne, {
                className: "TextContainer",
                children: (n == null ? void 0 : n.description) && /* @__PURE__ */ o(xe, {
                  type: "text",
                  textValue: n == null ? void 0 : n.description,
                  contentAlignment: (n == null ? void 0 : n.contentAlignment) || "center",
                  textVariant: "description"
                })
              })]
            })
          }, "" + (n == null ? void 0 : n.id));
        })
      }), /* @__PURE__ */ f(x.Body, {
        marketingTable: !0,
        isColumnButtonEnabled: G,
        children: [K.map(function(n) {
          var V;
          return /* @__PURE__ */ o(x.Row, {
            id: n == null ? void 0 : n.rowId,
            children: n == null || (V = n.cellData) == null ? void 0 : V.map(function(v, P) {
              var z, A, E, D, J, Q, ie;
              return /* @__PURE__ */ o(x.Cell, {
                as: P === 0 && "th" || "td",
                scope: P === 0 && "row" || void 0,
                $contentAlignment: ((z = a[P]) == null ? void 0 : z.contentAlignment) || "center",
                id: v == null ? void 0 : v.id,
                children: /* @__PURE__ */ o(x.CellContent, {
                  $contentAlignment: ((A = a[P]) == null ? void 0 : A.contentAlignment) || "center",
                  children: /* @__PURE__ */ o(de, {
                    type: v == null || (E = v.valueProp) == null ? void 0 : E.type,
                    textValue: v == null || (D = v.valueProp) == null ? void 0 : D.textValue,
                    informationPopuptipProp: v == null || (J = v.valueProp) == null ? void 0 : J.informationPopuptipProp,
                    informationTooltipProp: v == null || (Q = v.valueProp) == null ? void 0 : Q.informationTooltipProp,
                    contentAlignment: ((ie = a[P]) == null ? void 0 : ie.contentAlignment) || "center",
                    informationOption: v.informationOption
                  })
                })
              }, "" + (v == null ? void 0 : v.id));
            })
          }, "" + (n == null ? void 0 : n.rowId));
        }), G && /* @__PURE__ */ o(x.Row, {
          id: he("table_row_button"),
          children: a.map(function(n) {
            var V = (n == null ? void 0 : n.columnButton) || {}, v = V.isColumnButtonEnabled, P = v === void 0 ? !1 : v, z = V.buttonText, A = z === void 0 ? "" : z, E = V.as, D = re(V, Sn);
            return /* @__PURE__ */ o(x.Cell, {
              id: (n == null ? void 0 : n.id) + "_" + he("table_cell"),
              $contentAlignment: n == null ? void 0 : n.contentAlignment,
              children: /* @__PURE__ */ o(x.CellContent, {
                $contentAlignment: n == null ? void 0 : n.contentAlignment,
                children: P && /* @__PURE__ */ o(Be, Object.assign({
                  className: "MarketingComparisonTableColumnButton",
                  renderAs: E
                }, D, {
                  children: A
                }))
              })
            }, "" + (n == null ? void 0 : n.id));
          })
        })]
      })]
    })), !_ && W < Ve.laptopMin && /* @__PURE__ */ o(Bn, {
      headerValues: a,
      rowValues: h,
      isColumnButtonEnabled: G
    }), d && /* @__PURE__ */ o(Qe, {
      disclosureContent: d == null ? void 0 : d.disclosureContent,
      id: d == null ? void 0 : d.id,
      className: d == null ? void 0 : d.className,
      disclosureTitleColor: d == null ? void 0 : d.disclosureTitleColor,
      style: d == null ? void 0 : d.style
    })]
  }));
};
export {
  Zi as MarketingComparisonTable,
  Ie as MarketingComparisonTableColumnButton
};
